<div (click)="addProjectNotes()">
	<ng-content></ng-content>
</div>
